import { RefObject } from 'react';

import { cn } from '@/lib/utils';

interface PdfPagesScrollAreaProps {
  containerRef: RefObject<HTMLDivElement | null>;
  className?: string;
}

// The pages container must stay the direct child of the scrolling element:
// useCurrentPage and the zoom scroll restoration use its parentElement
export const PdfPagesScrollArea = ({
  containerRef,
  className,
}: PdfPagesScrollAreaProps) => (
  <div className={cn('w-full h-full overflow-auto px-4', className)}>
    <div ref={containerRef} className="mx-auto w-fit" />
  </div>
);
